<template>
  <form @submit.prevent="save" class="main-modal main-modal_w500 main-form">
    <div class="main-modal__title">
      <p>Wählen Sie den Grund der Ablehnung:</p>
    </div>

    <div class="main-form__box">
      <label class="main-form__label" for>Wählen Sie den Grund der Ablehnung:</label>
      <el-select
        v-model="form.reason"
        placeholder="Wählen Sie den Grund der Ablehnung:"
        style="width:100%"
      >
        <el-option
          v-for="item in reasons"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>

    <div>
      <label class="main-form__label" for>Kommentar</label>
      <textarea
        placeholder="Beschreiben Sie kurz die konkrete Situation. Die Anrufaufzeichnung wird angehört, um die Einhaltung zu überprüfen."
        class="main-form__textarea main-form__textarea_h80"
        v-model="form.comment"
      ></textarea>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">
        {{
        $t("global.cancel")
        }}
      </span>
      <button
        type="submit"
        :disabled="!isChecked"
        class="main-button main-button_success"
      >{{ $t("global.save") }}</button>
    </div>
  </form>
</template>

<script>
export default {
    data() {
        return {
            reasons: [
                {
                    value: 'Dublikate',
                    label: 'Dublikate',
                },
                {
                    value: 'mit dem Preis unzufrieden',
                    label: 'mit dem Preis unzufrieden',
                },
                {
                    value: 'Uhrzeit / Datum passt nicht',
                    label: 'Uhrzeit / Datum passt nicht',
                },
                {
                    value: 'Wir bieten diesen Service nicht an',
                    label: 'Wir bieten diesen Service nicht an',
                },
                {
                    value: 'Spam oder Fehler gemacht',
                    label: 'Spam oder Fehler gemacht',
                },
                {
                    value: 'andere',
                    label: 'andere',
                },
            ],
            form: {
                reason: '',
                comment: '',
            },
        }
    },
    computed: {
        isChecked() {
            if (this.form.reason === '') return false
            return this.form.comment.length >= 10
        },
    },
    methods: {
        save() {
            this.$emit('done', this.form)
        },
    },
}
</script>
